import { dark, light } from '@mui/material/styles/createPalette';
import React, { useState, useEffect } from 'react';

function Dark() {
  const [span, setspan] = useState(true);
  const [mystyle , setmystyle] = useState({
    dark: {
      backgroundColor: '#333333',
    },
    light: {
      backgroundColor: '#C996FF',
    }
  });

  useEffect(() => {
    document.body.style.backgroundColor = span ? mystyle.dark.backgroundColor : mystyle.light.backgroundColor;
  }, [span]);

  const togglespan = (e) => {
    const spanElement = e.currentTarget.children[0]; 
    spanElement.style.transform = span ? 'translateX(50px)' : 'translateX(0px)';
    setspan(!span); 
  }

  return (
    <div onClick={togglespan} className='w-24 h-10 my-4 border-2 border-zinc-100 rounded-full cursor-pointer'>
      <span className='w-10 h-9 duration-700 flex bg-white rounded-full absolute'></span>
    </div>
  );
}

export default Dark;